const imgTeamGoodsPackageGameboard = "./assets/figma/06744399-888e-4094-a77f-3c9a1652fb48.png";
const img3 = "./assets/figma/67472046-c77c-4ef7-bb78-1bb6338dc39a.png";
const img2026923382 = "./assets/figma/28434674-e6be-4dd7-bed7-6a17cba426a6.png";
const img2026923373 = "./assets/figma/0055b262-7091-4522-ae89-23e7c6b7377a.png";
const imgRectangle245 = "./assets/figma/0470d51d-5596-4e3f-9712-8c5cae2ec5cf.png";
const img125X1 = "./assets/figma/db1b1b95-b380-4f8f-b4ff-c974d2ac644c.png";
const img2 = "./assets/figma/2e6ee7a2-1725-486b-a263-795965ea1a2c.png";
const img4 = "./assets/figma/5bd64fb5-281b-41e3-af1f-4961e45f2415.png";
const imgLine21 = "./assets/figma/024cae05-40d5-40cd-8187-3cfbbb55f6fe.svg";
const img1 = "./assets/figma/12bba834-9dfb-408a-831d-4e0f805933eb.svg";
const imgLine25 = "./assets/figma/05a65c31-9eb5-4b95-a7ed-46d18eb9cd91.svg";
const imgLine26 = "./assets/figma/004e04b2-2999-4bf9-a0ef-7d979948c643.svg";
const imgLine27 = "./assets/figma/05a65c31-9eb5-4b95-a7ed-46d18eb9cd91.svg";
const imgRectangle243 = "./assets/figma/0dfb52b6-ae5c-4986-8e59-80bb7d314ca8.svg";
const imgRectangle246 = "./assets/figma/0f75945d-c052-4259-ba44-5c51f8242788.svg";
const imgClose = "./assets/figma/126d0178-fb8f-4298-97a5-6e9219784749.svg";

export default function TeamGoodsPackageGameboard() {
  return (
    <div className="s0 s1" data-node-id="875:135" data-name="TEAM_GOODS/PACKAGE/GAMEBOARD">
      <div aria-hidden className="s2 s3 s4">
        <div className="s2 s5 s3" />
        <div className="s2 s3 s6">
          <img alt="" className="s2 s7 s321 s9 s10 s322" src={imgTeamGoodsPackageGameboard} />
        </div>
      </div>
      <div className="s2 s12 s13 s14 s15" data-node-id="875:138" data-name="image 14" />
      <div className="s2 s16 s17 s18 s19 s20 s323 s22" data-node-id="875:139">
        <div className="s23 s16 s17 s24 s25 s26 s27 s0 s28 s29 s30" data-node-id="875:140">
          <p className="s31 s32 s0 s28 s33 s34" data-node-id="875:141">
            PROJECT OVERVIEW
          </p>
          <p className="s35 s39 s0 s28 s37 s34" data-node-id="875:142">
            DOMINO TILES · 30 × 48 × 5 MM · 15
            <br aria-hidden />
            GAME BOARD · 550 × 550 MM · 1<br aria-hidden />
            CARDS · 63 × 88 MM · 20
            <br aria-hidden />
            INSTRUCTION PANEL
          </p>
        </div>
        <div className="s17 s41 s18 s42 s0 s28 s43" data-node-id="875:143">
          <div className="s44 s45">
            <div className="s46 s0 s47">
              <div className="s2 s48">
                <img alt="" className="s49 s9 s1" src={imgLine21} />
              </div>
            </div>
          </div>
        </div>
        <div className="s23 s16 s17 s24 s25 s26 s27 s0 s28 s29 s50" data-node-id="875:144">
          <p className="s31 s32 s0 s28 s33 s34" data-node-id="875:145">
            MEMBERS
          </p>
          <p className="s35 s39 s0 s28 s37 s34" data-node-id="875:146">
            신지수
            <br aria-hidden />
            윤현서
            <br aria-hidden />
            지윤주
            <br aria-hidden />
            홍민지
          </p>
        </div>
      </div>
      <p className="s23 s2 s51 s32 s52 s27 s29 s33 s324 s54" data-node-id="875:147">
        LET THE IDEAS ROLL, PLAY THE LAB
      </p>
      <div className="s23 s2 s16 s17 s24 s25 s26 s55 s27 s29 s325 s57" data-node-id="875:148">
        <p className="s31 s32 s0 s28 s58 s59" data-node-id="875:149">
          ABOUT
        </p>
        <div className="s35 s36 s0 s28 s37 s59 s38" data-node-id="875:150">
          <p className="s39 s40">{`패키지/굿즈팀은 원하는 결과에 도달하기 위해 AI를 선택하고 조합하는 과정을 도미노 보드게임 패키지로 `}</p>
          <p className="s39 s40">{`시각화했다. 2~4명의 플레이어는 게임 시작 시 결과 구슬 카드를 뽑아 목표를 정하고 AI 도미노를 나누어 가진다. `}</p>
          <p className="s39 s40">{`이후 카드에 제시된 조건에 맞는 도미노를 골라 순서대로 연결하며 각자의 AI 파이프라인을 구성한다. `}</p>
          <p className="s39 s40">{`조건을 가장 먼저 충족해 도미노 라인을 완성한 플레이어가 승리하고, 완성된 도미노를 직접 쓰러뜨리며 AI의 `}</p>
          <p className="s39">선택과 조합에서 결과 도출까지 이어지는 과정을 놀이로 경험하도록 제작했다.</p>
        </div>
      </div>
      <p className="s23 s2 s31 s32 s326 s27 s29 s61 s62 s54" data-node-id="875:151">
        GOODS/PACKAGE
      </p>
      <div className="s2 s17 s327 s18 s42 s328 s325 s329" data-node-id="875:152">
        <div className="s330 s44 s331">
          <div className="s327 s0 s329" data-name="패키지팀 3">
            <img alt="" className="s2 s3 s9 s105 s4 s1" src={img3} />
          </div>
        </div>
      </div>
      <div className="s2 s16 s17 s24 s332 s26 s20 s333 s334" data-node-id="875:153">
        <p className="s23 s31 s32 s27 s0 s28 s29 s64 s34" data-node-id="875:154">
          WORK
        </p>
        <div className="s16 s17 s18 s19 s36 s0 s28 s34" data-node-id="875:155" data-name="TEAM_GOODS/PACKAGE_WORK">
          <div className="s335 s336 s337 s338 s0 s28" data-node-id="875:156">
            <div className="s192 s335 s336 s337 s339 s340 s338 s0 s198" data-node-id="875:157">
              <div className="s192 s69 s339 s340 s0 s70 s198 s71" data-node-id="875:158" data-name="이미지 2026. 9. 2. 오후 3.38 2">
                <div className="s2 s3 s6 s4 s70">
                  <img alt="" className="s2 s341 s342 s9 s10 s343" src={img2026923382} />
                </div>
              </div>
              <div className="s76 s192 s344 s69 s339 s340 s0 s70 s198 s78 s79 s71" data-node-id="875:159" />
            </div>
            <div className="s80 s192 s81 s69 s339 s340 s82 s0 s70 s198 s71" data-node-id="875:160" />
            <p className="s23 s192 s31 s32 s345 s346 s27 s0 s198 s29 s33 s85 s54" data-node-id="875:161">
              DOMINO TILES
            </p>
          </div>
          <div className="s335 s336 s337 s338 s0 s28" data-node-id="875:162">
            <div className="s192 s17 s69 s18 s42 s339 s340 s0 s198 s71" data-node-id="875:163">
              <div className="s330 s44 s331">
                <div className="s69 s0 s70 s71" data-name="패키지팀 4">
                  <img alt="" className="s2 s3 s9 s105 s4 s70 s1" src={img3} />
                </div>
              </div>
            </div>
            <div className="s76 s192 s344 s69 s339 s340 s0 s70 s198 s78 s79 s71" data-node-id="875:164" />
            <div className="s80 s192 s81 s69 s339 s340 s82 s0 s70 s198 s71" data-node-id="875:165" />
            <div className="s23 s192 s31 s347 s346 s27 s0 s198 s29 s33 s85 s54" data-node-id="875:166">
              <p className="s94 s40">GAME BOARD</p>
              <p className="s94">INSTRUCTION PANEL</p>
            </div>
          </div>
          <div className="s335 s336 s337 s338 s0 s28" data-node-id="875:167">
            <div className="s192 s69 s339 s340 s0 s70 s198 s348 s71" data-node-id="875:168" data-name="이미지 2026. 9. 2. 오후 3.37 3">
              <div className="s2 s3 s6 s4 s70">
                <img alt="" className="s2 s349 s350 s9 s10 s351" src={img2026923373} />
              </div>
            </div>
            <div className="s76 s192 s77 s69 s339 s340 s0 s70 s198 s79 s71" data-node-id="875:169" />
            <div className="s80 s192 s81 s69 s339 s340 s82 s0 s70 s198 s71" data-node-id="875:170" />
            <p className="s23 s192 s31 s94 s352 s346 s27 s0 s198 s29 s33 s85 s54" data-node-id="875:171">
              CARDS
            </p>
          </div>
        </div>
      </div>
      <div className="s2 s102 s103 s10 s104" data-node-id="875:172">
        <img alt="" className="s2 s3 s9 s105 s4 s1" src={imgRectangle245} />
      </div>
      <div className="s106 s2 s16 s17 s18 s19 s107 s108 s109" data-node-id="875:173" data-name="navigationbar">
        <div className="s16 s17 s110 s26 s0 s28" data-node-id="875:174">
          <div className="s111 s0 s28 s112" data-node-id="875:175" data-name="_레이어_1">
            <img alt="" className="s2 s49 s3 s9 s1" src={img1} />
          </div>
          <p className="s23 s31 s113 s32 s27 s0 s28 s29 s114 s115 s116" data-node-id="875:180">
            DING AI LAB
          </p>
        </div>
        <div className="s16 s17 s117 s18 s0 s28" data-node-id="875:181">
          <div className="s16 s17 s24 s118 s18 s0 s28 s119" data-node-id="875:182">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="875:183">
              PROJECT
            </p>
            <div className="s46 s0 s28 s34" data-node-id="875:184">
              <img alt="" className="s2 s49 s3 s9 s1" src={imgLine25} />
            </div>
          </div>
          <div className="s16 s17 s24 s118 s18 s0 s28 s123" data-node-id="875:185">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="875:186">
              TEAM
            </p>
            <div className="s46 s0 s28 s34" data-node-id="875:187">
              <div className="s2 s48">
                <img alt="" className="s49 s9 s1" src={imgLine26} />
              </div>
            </div>
          </div>
          <div className="s16 s17 s24 s118 s18 s0 s28 s124" data-node-id="875:188">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="875:189">
              ABOUT
            </p>
            <div className="s46 s0 s28 s34" data-node-id="875:190">
              <img alt="" className="s2 s49 s3 s9 s1" src={imgLine27} />
            </div>
          </div>
        </div>
      </div>
      <div className="s2 s353 s354 s10 s104" data-node-id="875:191">
        <div className="s2 s355">
          <img alt="" className="s49 s9 s1" src={imgRectangle243} />
        </div>
      </div>
      <div className="s106 s2 s128 s126 s10 s104" data-node-id="875:496">
        <div className="s2 s129">
          <img alt="" className="s49 s9 s1" src={imgRectangle246} />
        </div>
      </div>
      <div className="s106 s2 s67 s126 s356" data-node-id="875:243">
        <div className="s2 s5 s357 s153 s156 s157 s356 s158" data-node-id="863:5789" />
        <p className="s23 s2 s31 s36 s390 s27 s29 s137 s391 s54" data-node-id="863:5790">
          <span className="s32">INSTRUCTION PANEL</span>
          <span className="s32">{` DESIGN`}</span>
        </p>
        <p className="s23 s2 s31 s32 s392 s27 s29 s160 s359 s54" data-node-id="863:5791">
          GAME BOARD
        </p>
        <p className="s23 s2 s31 s32 s393 s27 s29 s137 s394 s54" data-node-id="863:5792">
          GAME BOARD DESIGN
        </p>
        <div className="s2 s395 s396 s397 s398" data-node-id="863:5801" data-name="예상디피목업@1.25x 1">
          <div className="s2 s3 s6 s4">
            <img alt="" className="s2 s399 s103 s9 s400 s34" src={img125X1} />
          </div>
        </div>
        <div className="s2 s189 s401 s402" data-node-id="863:5802" data-name="게임판 1">
          <img alt="" className="s2 s3 s9 s105 s4 s1" src={img2} />
        </div>
        <div className="s23 s2 s35 s403 s36 s404 s27 s29 s174 s405 s406 s38" data-node-id="863:5803">
          <p className="s175 s40">{`도미노를 연결하여 최종 완성 됐을 시, 도미노를 무너뜨릴 수 `}</p>
          <p className="s175 s40">{`있도록 게임판을 구성하였다. 테이블에 앉아서 게임을 하게 `}</p>
          <p className="s175 s40">될 것을 예측해 대각선을 배치하는 방향으로 진행했다.</p>
          <p className="s175 s40">​</p>
          <p className="s175 s40">{`첫 아이디어를 상징하는 투명 구슬 그래픽을 플레이어 앞에 `}</p>
          <p className="s175 s40">{`배치하고, 가운데에 결과구슬카드를 공개함으로써 도미노 `}</p>
          <p className="s175">파이프가 완성됐을 때, 투명한 구슬에서 결과로 완성되는 흐름을 나타내고자 했다.</p>
        </div>
        <div className="s2 s17 s407 s18 s42 s404 s408 s409" data-node-id="863:5804">
          <div className="s330 s44 s45">
            <div className="s410 s0 s411" data-name="패키지팀 3">
              <img alt="" className="s2 s3 s9 s105 s4 s1" src={img3} />
            </div>
          </div>
        </div>
        <div className="s2 s412 s189 s413 s414" data-node-id="863:5805" data-name="패키지팀 판넬 1">
          <img alt="" className="s2 s3 s9 s105 s4 s1" src={img4} />
        </div>
      </div>
      <div className="s2 s16 s17 s24 s378 s26 s20 s132 s133" data-node-id="875:228" data-name="PROJECT_CATEGORY_TABS_GOODS/PACKAGE">
        <p className="s23 s31 s32 s379 s27 s0 s28 s58 s138 s380" data-node-id="875:229">
          GOODS/PACKAGE
        </p>
        <div className="s16 s17 s139 s18 s0 s28 s140" data-node-id="863:5793" data-name="PROJECT_CATEGORY_TABS_GOODS/PACKAGE">
          <a className="s16 s141 s17 s18 s42 s142 s143 s144 s0 s145 s146 s28" data-node-id="863:5794" data-name="TAB_DOMINO_TILES">
            <div aria-hidden className="s2 s147 s3 s4 s145" />
            <p className="s23 s31 s32 s27 s0 s28 s148 s149 s138 s54" data-node-id="863:5795">
              DOMINO TILES
            </p>
            <div className="s2 s3 s4 s150 s151" />
          </a>
          <div className="s16 s81 s17 s18 s42 s142 s143 s144 s0 s145 s28" data-node-id="863:5796" data-name="TAB_GAMEBOARD">
            <div aria-hidden className="s2 s152 s3 s4 s145" />
            <p className="s23 s31 s32 s27 s0 s28 s29 s148 s54" data-node-id="863:5797">
              GAME BOARD
            </p>
            <div className="s2 s3 s4 s150 s151" />
          </div>
          <a className="s16 s141 s17 s18 s42 s142 s143 s144 s0 s145 s146 s28" data-node-id="863:5798" data-name="TAB_CARDS">
            <div aria-hidden className="s2 s147 s3 s4 s145" />
            <p className="s23 s31 s32 s27 s0 s28 s148 s149 s138 s54" data-node-id="863:5799">
              CARDS
            </p>
            <div className="s2 s3 s4 s150 s151" />
          </a>
        </div>
      </div>
      <button className="s2 s49 s141 s211 s212 s213" data-node-id="891:154" data-name="close">
        <img alt="" className="s2 s49 s3 s9 s1" src={imgClose} />
      </button>
    </div>
  );
}